var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6358 1.40901C14.7571 0.530332 13.3324 0.530329 12.4537 1.40901L1.83558 12.0272C1.52148 12.3413 1.30738 12.7414 1.22027 13.1769L0.779963 15.3785C0.570047 16.428 1.49543 17.3534 2.54501 17.1435L4.74651 16.7032C5.18209 16.6161 5.58214 16.402 5.89624 16.0879L16.5144 5.46967C17.3931 4.59099 17.3931 3.16637 16.5144 2.28769L15.6358 1.40901ZM13.5144 2.46967C13.8073 2.17678 14.2822 2.17678 14.5751 2.46967L15.4537 3.34835C15.7467 3.64124 15.7467 4.11611 15.4537 4.40901L13.45 6.4127L11.5108 4.47336L13.5144 2.46967ZM10.45 5.53402L2.89624 13.0879C2.79154 13.1926 2.72018 13.3259 2.69114 13.4711L2.25083 15.6726L4.45234 15.2323C4.59753 15.2032 4.73088 15.1319 4.83558 15.0272L12.3894 7.47336L10.45 5.53402Z",
    fill: "#525866"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/editPencilIcon.9775b4135676fd580ebd7a7fbe0204f6.svg";
export { ForwardRef as ReactComponent };